import { Link, useLocation } from "react-router-dom";

const NavItem = ({
  src,
  alt,
  text,
  icon,
  pathname,
  asLink = true,
  isActive = false,
}) => {
  const location = useLocation();

  const active =
    isActive ||
    (pathname
      ? pathname === "/"
        ? location.pathname === "/"
        : location.pathname.startsWith(pathname)
      : false);

  const content = (
    <div
      className={`flex items-center gap-2 ${
        active ? "text-secondary" : "text-primary"
      }`}
    >
      {src && <img src={src} alt={alt} />}
      <span
        className={`2xl:text-base text-xs font-semibold relative pb-1 ${
          active ? "text-secondary" : "text-primary"
        }`}
      >
        {text}
        {active && (
          <span className="absolute bottom-0 left-0 w-full h-0.5 bg-secondary"></span>
        )}
        {icon && (
          <span className="text-secondary font-bold text-base">{icon}</span>
        )}
      </span>
    </div>
  );

  if (asLink) {
    return (
      <Link
        to={pathname}
        className={`hover:text-secondary transition-colors duration-200 ${
          active ? "text-secondary" : "text-primary"
        }`}
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default NavItem;
